import * as HttpService from "../../../../service/HttpService";
/**
 *  查询管控记录
 */
export const getControlrecord = (params) => {
    return HttpService.post(HttpService.DOMAIN +"/alarmManage/getControlRecord", params);
};